var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsArrowBottomSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_arrow_bottom",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_3930",
    "data-name": "\\u9577\\u65B9\\u5F62 3930",
    width: 16,
    height: 16,
    transform: "translate(0 0.002)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1553",
    "data-name": "\\u30D1\\u30B9 1553",
    d: "M8.034,14.964a1.329,1.329,0,0,1-.943-.391L0,7.482,7.092.39A1.333,1.333,0,0,1,8.977,2.276L3.771,7.482l5.206,5.206a1.333,1.333,0,0,1-.943,2.276Z",
    transform: "translate(0.384 12.961) rotate(-90)",
    fill: "#3b4d4f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsArrowBottomSmall);
export default __webpack_public_path__ + "static/media/icons_arrow_bottom_small.dc10f718e2ef5bb2c2c0ddb2ef446729.svg";
export { ForwardRef as ReactComponent };